// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2bUxV","footer":"ModalUpdate_footer__smVdE"};